(function() {
    'use strict';

    var module = angular.module(
        'app',
        ['ui.router', 'ngAnimate', 'ngStorage', 'angularMoment', 'loadingPane', 'angularModalService', 'jkuri.datepicker']);

    module.run([
        '$state', 'currentUserService', 'bus', 'authenticationEvents', '$rootScope',
        function($state, currentUserService, bus, authenticationEvents, $rootScope) {
            var redirectIfUserNotInRole = function(requiredRoles) {
                var currentUser = currentUserService.getCurrentUser();
                if (!currentUser)
                    $state.go('home');
                else if (_.intersection(requiredRoles, currentUser.roles).length === 0) {
                    $state.go('home');
                }
            };
            $rootScope.$on(
                '$stateChangeSuccess',
                function(e, toState) {
                    if (toState.data && toState.data.requiredRoles) {
                        redirectIfUserNotInRole(toState.data.requiredRoles);
                    }
                });

            bus.subscribe(
                authenticationEvents.logoutSuccess,
                function() {
                    if ($state.current.data && $state.current.data.requiredRoles) {
                        redirectIfUserNotInRole($state.current.requiredRoles);
                    }
                });
        }
    ]);

    module.config([
        '$stateProvider', '$urlRouterProvider',
        function($stateProvider, $urlRouterProvider) {

            // For any unmatched url, redirect to /state1
            $urlRouterProvider.otherwise('/');

            // Now set up the states
            $stateProvider
                .state(
                    'home',
                    {
                        url: '/',
                        template: '<home></home>',
                    })
                .state(
                    'topFive',
                    {
                        url: '/topFive',
                        template: '<top-five></top-five>'
                    })
                .state(
                    'findMyWine',
                    {
                        url: '/findMyWine',
                        template: '<find-my-wine></find-my-wine>'
                    })
                .state(
                    'cellar',
                    {
                        url: '/cellar',
                        template: '<cellar></cellar>'
                    })
                .state(
                    'freight',
                    {
                        url: '/freight',
                        template: '<freight></freight>'
                    })
                .state(
                    'aboutUs',
                    {
                        url: '/aboutUs',
                        template: '<about-us></about-us>'
                    })
                .state(
                    'contact',
                    {
                        url: '/contact',
                        template: '<contact></contact>'
                    })
                .state(
                    'sitemap',
                    {
                        url: '/sitemap',
                        template: '<sitemap></sitemap>'
                    })
                .state(
                    'termsAndConditions',
                    {
                        url: '/termsAndConditions',
                        template: '<terms-and-conditions>'
                    })
                .state(
                    'myCellar',
                    {
                        url: '/myCellar',
                        template: '<my-cellar></my-cellar>',
                        data: {
                            requiredRoles: ['User']
                        }
                    })
                .state(
                    'admin',
                    {
                        url: '/admin',
                        template: '<admin></admin>',
                        data: {
                            requiredRoles: ['Admin']
                        }
                    });
        }
    ]);
}());